import { setOptions } from '@googlemaps/js-api-loader';

setOptions({
    key: 'AIzaSyB0DhEqDe1BWbbTGL_ycHBCjroikRYz9Eo',
    v: 'weekly',
    language: window.servercontext.languageCode,
    region: window.servercontext.countryCode,
});
